import { useForm } from 'react-hook-form'
import { Stack } from '@mui/material'
import { SearchStatusSelect } from '../components/statusSelect'

import { SearchResult, SearchTaskStatusFormData } from 'interface/search'
import {
  cancerStatusList,
  dpcStatusList,
  journalStatusList,
  senmoniStatusList,
  trialStatusList,
  guidelineStatusList,
  researchStatusList
} from 'interface/search/statusList'

export const useSearchStatusForm = (
  search: SearchResult
) => {
  return {
    search,
    form: useForm<SearchTaskStatusFormData>({
      defaultValues: {
        cancer: search.taskStatus?.cancer ?? 0,
        journal: search.taskStatus?.journal ?? 0,
        dpc: search.taskStatus?.dpc ?? 0,
        trial: search.taskStatus?.trial ?? 0,
        senmoni: search.taskStatus?.senmoni ?? 0,
        guideline: search.taskStatus?.guideline ?? 0,
        research: search.taskStatus?.research ?? 0
      }
    })
  }
}

export const SearchStatusForm = ({
  form: {
    control
  }
}: ReturnType<typeof useSearchStatusForm>) => (
  <Stack direction="column" spacing={1}>
    <SearchStatusSelect
      control={control}
      name="cancer"
      id="check-status-cancer"
      label="がん情報"
      options={cancerStatusList}
    />
    <SearchStatusSelect
      control={control}
      name="dpc"
      id="check-status-dpc"
      label="DPC"
      options={dpcStatusList}
    />
    <SearchStatusSelect
      control={control}
      name="journal"
      id="check-status-journal"
      label="論文"
      options={journalStatusList}
    />
    <SearchStatusSelect
      control={control}
      name="trial"
      id="check-status-trial"
      label="治験"
      options={trialStatusList}
    />
    <SearchStatusSelect
      control={control}
      name="senmoni"
      id="check-status-senmoni"
      label="専門医"
      options={senmoniStatusList}
    />
    <SearchStatusSelect
      control={control}
      name="guideline"
      id="check-status-guideline"
      label="ガイドライン"
      options={guidelineStatusList}
    />
    <SearchStatusSelect
      control={control}
      name="research"
      id="check-status-research"
      label="研究"
      options={researchStatusList}
    />
  </Stack>
)
